import React from 'react';
import { Form } from '@dashboard/components/Formik';
import { hasStripeManagedPrice } from '@dashboard/services/getBillingModel';
import useProduct from '../useProduct';

const PurchaseLimitsForm = () => {
  const { product, updateProduct } = useProduct();

  const stripeManaged = hasStripeManagedPrice(product);

  return (
    <Form
      initialValues={{
        limitPayments: {
          enabled: product?.limitPayments?.enabled,
        },
        limitSubscriptions: {
          enabled: product?.limitSubscriptions?.enabled,
          limitSubscriptionsStripe: {
            enabled: product?.limitSubscriptions?.limitSubscriptionsStripe?.enabled,
          },
        },
      }}
      fields={() => [
        {
          name: 'limitPayments.enabled',
          required: false,
          type: 'checkbox',
          label: 'Prevent repeat purchases',
          helpText: 'Limit each customer to one purchase of this product.',
        },
        stripeManaged
          ? {
              name: 'limitSubscriptions.limitSubscriptionsStripe.enabled',
              required: false,
              type: 'checkbox',
              label: 'Prevent repeat subscriptions to this Stripe price',
              helpText:
                'Turn this on for every product you sell with this Stripe price, so customers can start one subscription to it.',
            }
          : {
              name: 'limitSubscriptions.enabled',
              required: false,
              type: 'checkbox',
              label: 'Prevent repeat subscriptions',
              helpText: 'Limit each customer to one subscription to this product.',
            },
      ]}
      onSubmit={async (values, actions) => {
        // enabledAt is stamped server-side and never sent. The nested shape
        // needs the master on for stripe mode, so the master mirrors the
        // stripe toggle there — and a stale hidden stripe value must never
        // resurrect the master in native mode.
        const stripeEnabled = stripeManaged
          ? values.limitSubscriptions?.limitSubscriptionsStripe?.enabled === true
          : false;
        const masterEnabled = stripeManaged
          ? stripeEnabled
          : values.limitSubscriptions?.enabled === true;

        const payload = {
          limitPayments: { enabled: values.limitPayments?.enabled === true },
          limitSubscriptions: {
            enabled: masterEnabled,
            limitSubscriptionsStripe: { enabled: stripeEnabled },
          },
        };

        const { data, error } = await updateProduct.mutateAsync(payload);

        if (data) {
          actions.resetForm({ values: payload });
        }

        return { data, error };
      }}
    />
  );
};

export default PurchaseLimitsForm;
